import {Pipe, PipeTransform} from '@angular/core';
import {FilterByFieldPipe} from "@pipes";

@Pipe({
    name: 'getByField'
})
export class GetByFieldPipe implements PipeTransform {

    constructor(private filterByFieldPipe: FilterByFieldPipe) {
    }

    transform(items: any[] | undefined, field: string, value: any, returnField?: string | undefined, differentThanValue?: boolean | undefined): any {
        const filteredItems = this.filterByFieldPipe.transform(items, field, value, differentThanValue);
        return filteredItems.length > 0 ? !returnField ? filteredItems.at(0) : filteredItems.at(0)[returnField]: undefined;
    }
}
